export default __webpack_public_path__ + "static/media/folio-minor.ddeed88e.svg";